import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  EventEditorPageSkeleton,
  EventsListPageSkeleton,
} from "../events/EventPageSkeletons";
import { useAuth } from "./AuthContext";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    if (location.pathname === "/events") {
      return <EventsListPageSkeleton />;
    }

    if (location.pathname === "/events/new") {
      return <EventEditorPageSkeleton />;
    }

    if (location.pathname.startsWith("/events/")) {
      return (
        <EventEditorPageSkeleton
          headerProps={{ backTo: "/events", backLabel: "Back to events" }}
        />
      );
    }

    return (
      <div className="auth-loading" role="status">
        Loading your workspace…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
